// Copyright 2025 Imprivata, Inc. All rights reserved.

import { useTranslation } from 'react-i18next';
import HexAnimationImg from '../../../../../assets/animated/hex-animation.gif';
import './ImportUsersModal.less';

const TRANSLATION_ROOT = 'portal.settings.identity-users.import-users-modal';

interface ImportUsersLoadingProps {
  fileName: string;
}

const ImportUsersLoading = ({ fileName }: ImportUsersLoadingProps) => {
  const { t } = useTranslation();

  return (
    <div className="loading">
      <img src={HexAnimationImg} alt={'Loading'} className="loading-gif" />
      <p className="loading-text">{t(`${TRANSLATION_ROOT}.loading-file`, { fileName })}</p>
    </div>
  );
};

export default ImportUsersLoading;
